import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ExperienceSection.css'; // You'll need to create this CSS file

function Exp() {
  const [yearsCounter, setYearsCounter] = useState(0);
  const [projectsCounter, setProjectsCounter] = useState(0);
  const [clientsCounter, setClientsCounter] = useState(0);

  useEffect(() => {
    // Animate the years counter
    const yearsInterval = setInterval(() => {
      setYearsCounter(prev => {
        if (prev < 9) return prev + 1;
        clearInterval(yearsInterval);
        return 9;
      });
    }, 200);

    // Animate the projects counter
    const projectsInterval = setInterval(() => {
      setProjectsCounter(prev => {
        if (prev < 250) return prev + 10;
        clearInterval(projectsInterval);
        return 250;
      });
    }, 50);

    // Animate the clients counter
    const clientsInterval = setInterval(() => {
      setClientsCounter(prev => {
        if (prev < 100) return prev + 5;
        clearInterval(clientsInterval);
        return 100;
      });
    }, 75);

    // Cleanup intervals on component unmount
    return () => {
      clearInterval(yearsInterval);
      clearInterval(projectsInterval);
      clearInterval(clientsInterval);
    };
  }, []);

  return (
    <section className="experience-section py-5">
      <div className="container">
        <div className="row text-center mb-5">
          <div className="col-12">
            <h2 className="section-title5" style={{color:"white"}}>Years of Excellence in Bahrain</h2>
            <p className="section-subtitle5" >Delivering outstanding solutions since 2016</p>
          </div>
        </div>

        <div className="row">
          {/* Years of Experience Card */}
          <div className="col-md-4 mb-4">
            <div className="stat-card">
              <div className="icon-wrapper">
                <i className="bi bi-clock"></i>
              </div>
              <h3 className="counter-value">{yearsCounter}+</h3>
              <p className="counter-title">Years Experience</p>
            </div>
          </div>

          {/* Projects Card */}
          <div className="col-md-4 mb-4">
            <div className="stat-card">
              <div className="icon-wrapper">
                <i className="bi bi-award"></i>
              </div>
              <h3 className="counter-value">{projectsCounter}+</h3>
              <p className="counter-title">Projects Completed</p>
            </div>
          </div>

          {/* Clients Card */}
          <div className="col-md-4 mb-4">
            <div className="stat-card">
              <div className="icon-wrapper">
                <i className="bi bi-people"></i>
              </div>
              <h3 className="counter-value">{clientsCounter}+</h3>
              <p className="counter-title">Happy Clients</p>
            </div>
          </div>
        </div>

        <div className="row mt-4">
          <div className="col-12 text-center">
            <button className="btn btn-outline-light btn-cta">
              <i className="bi bi-lightning me-2"></i>
              Discover Our Services
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Exp;